import { Control, Controller } from 'react-hook-form';

import { ArtiaButtonLink } from '@/components/artia-button';
import { CurrencyTextInput } from '@/components/form-controls';
import { CalculationDetails } from '@/types/calculation-details';
import { OverridableCalculatedValue } from '@/types/overridable-calculated-value';
import { formatCurrency } from '@/utils/formatting';

type EstimatedTotalUraCellProps = {
  ndc: string
  ura?: OverridableCalculatedValue
  onViewCalculationDetails: (calculationDetails: CalculationDetails) => void;
  isOverriding: boolean,
  control: Control<any>,
};

export const EstimatedTotalUraCell = ({ ndc, ura, isOverriding, control, onViewCalculationDetails }: EstimatedTotalUraCellProps) => {
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  const handleValueClick = () => onViewCalculationDetails(ura.calculatedValue);

  const formKey = `${ndc}.ura`;

  return (
    <div className="min-w-32">
      {isOverriding
        && <Controller
          control={control}
          name={formKey}
          render={({ field: { value, onChange, onBlur } }) => (
            <CurrencyTextInput
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              id={formKey}
              name={formKey}
            />
          )}
        />
      }

      {!isOverriding && ura?.overrideValue != null
        && <span>{formatCurrency(ura.overrideValue, 4, 4)}</span>
      }

      {!isOverriding && ura?.overrideValue == null && ura?.calculatedValue?.value != null
        && <ArtiaButtonLink onClick={handleValueClick}>
          {formatCurrency(ura.calculatedValue.value, 4, 4)}
        </ArtiaButtonLink>
      }
    </div>
  );
};
